import { Box, Container, Grid } from "@mui/material";
import React from "react";
import styled from "styled-components";
import { useTranslation } from 'react-i18next';
import CustomLink from "../../../Components/CustomLink/CustomLink";
import FeatImage01 from "../../../assets/images/dashboard-hairdresserbooking-fotor-bg-remover-20230522222429.png";

const CTASection = () => {
  const { t } = useTranslation();

  return (
    <CTAContainer className="dtree_section_header">
      <Container>
        <ContentWrapper>
          {/* Left Side Text */}
          <TextContent>
            <TargetAudience className="poppins-medium">
              {t('CTASection.targetAudience')}
            </TargetAudience>
            <StyledH3 className="archivo-bold">
              {t('CTASection.title')}
            </StyledH3>
            <StyledP>
              {t('CTASection.description')}
            </StyledP>
            <BenefitsList>
              <BenefitItem>
                <BenefitIcon>✓</BenefitIcon>
                {t('CTASection.benefit1')}
              </BenefitItem>
              <BenefitItem>
                <BenefitIcon>✓</BenefitIcon>
                {t('CTASection.benefit2')}
              </BenefitItem>
              <BenefitItem>
                <BenefitIcon>✓</BenefitIcon>
                {t('CTASection.benefit3')}
              </BenefitItem>
            </BenefitsList>
            <CustomLink to={'#'} className="nav-item nav-link rounded-button filled-button action-button">
              {t('CTASection.button')}
            </CustomLink>
          </TextContent>

          {/* Right Side Screens */}
          <DevicesContainer>
            <Grid
              container
              spacing={2}
              justifyContent="center"
              alignItems="flex-end"
            >
              {/* Web Screen */}
              <DeviceItem item xs={4} zIndex={1} transform="scale(1.2) translateY(20px)">
                <StyledImage src={FeatImage01} alt="Web Screen" />
                <StyledCaption>{t('CTASection.webCaption')}</StyledCaption>
              </DeviceItem>

              {/* Mobile Screen */}
              <DeviceItem item xs={4} zIndex={3} transform="scale(1.3) translateY(-40px)">
                <StyledImage src={FeatImage01} alt="Mobile Screen" />
                <StyledCaption>{t('CTASection.mobileCaption')}</StyledCaption>
              </DeviceItem>

              {/* Tablet Screen */}
              <DeviceItem item xs={4} zIndex={0} transform="scale(1) translateY(30px)">
                <StyledImage src={FeatImage01} alt="Tablet Screen" />
                <StyledCaption>{t('CTASection.tabletCaption')}</StyledCaption>
              </DeviceItem>
            </Grid>
          </DevicesContainer>
        </ContentWrapper>
      </Container>
    </CTAContainer>
  );
};

// Styled Components
const CTAContainer = styled.div`
  background: linear-gradient(135deg, #00164f 0%, #2a075a 100%);
  color: #fff;
  padding: 80px 0;
`;

const ContentWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 60px;
  
  @media (min-width: 900px) {
    flex-direction: row;
    align-items: center;
  }
`;

const TextContent = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
  text-align: center;
  
  @media (min-width: 900px) {
    text-align: left;
  }
`;

const DevicesContainer = styled(Box)`
  flex: 1;
  position: relative;
  height: 400px;
  
  @media (max-width: 900px) {
    height: 350px;
  }
`;

const DeviceItem = styled(Grid)`
  position: relative;
  z-index: ${({ zIndex }) => zIndex};
  transform: ${({ transform }) => transform};
  transition: transform 0.3s ease;
  
  &:hover {
    transform: ${({ transform }) => transform.replace(')', '')} scale(1.05));
    z-index: 10;
  }
`;

const TargetAudience = styled.div`
  text-transform: uppercase;
  color: #A3C9F9;
  font-size: 0.9rem;
  letter-spacing: 1.5px;
  margin-bottom: 10px;
`;

const StyledH3 = styled.h3`
  font-size: 2.5rem;
  margin-top: 0;
  margin-bottom: 20px;
  line-height: 1.2;
  background: linear-gradient(to right, #fff 0%, #a3c9f9 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  
  @media (max-width: 900px) {
    font-size: 2rem;
  }
`;

const StyledP = styled.p`
  font-size: 1.1rem;
  margin-bottom: 25px;
  line-height: 1.7;
  color: #e6e9f2;
`;

const BenefitsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 30px;
  text-align: left;
  
  @media (max-width: 900px) {
    text-align: center;
  }
`;

const BenefitItem = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  font-size: 1rem;
  color: #fff;
  
  @media (max-width: 900px) {
    justify-content: center;
  }
`;

const BenefitIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: #664de4;
  border-radius: 50%;
  margin-right: 12px;
  font-weight: bold;
`;

const StyledImage = styled.img`
  width: 100%;
  border-radius: 12px;
  box-shadow: 0px 15px 30px rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.1);
  object-fit: contain;
  transition: all 0.3s ease;
  
  ${DeviceItem}:hover & {
    box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.5);
    border-color: rgba(255, 255, 255, 0.3);
  }
`;

const StyledCaption = styled.p`
  text-align: center;
  margin-top: 15px;
  font-size: 0.9rem;
  color: #A3C9F9;
  opacity: 0.8;
  transition: opacity 0.3s;
  
  ${DeviceItem}:hover & {
    opacity: 1;
  }
`;

export default CTASection;
// import { Box, Container, Grid } from "@mui/material";
// import React from "react";
// import styled from "styled-components";

// // import WebScreen from "../../../assets/images/web-screen.png";
// // import TabletScreen from "../../../assets/images/ipad-screen.png";
// // import MobileScreen from "../../../assets/images/mobile-screen.png";
// import CustomLink from "../../../Components/CustomLink/CustomLink";
// import FeatImage01 from "../../../assets/images/dashboard-hairdresserbooking-fotor-bg-remover-20230522222429.png";

// const CTASection = () => {
//   return (
//     <div className="dtree_section_header" style={{ backgroundColor: "#00164f", color: "#fff", padding: "60px 0" }}>
//       <Container>
//         <Box
//           sx={{
//             borderRadius: "20px",
//             padding: "0 20px",
//             display: "flex",
//             flexDirection: {
//               xs: "column",
//               md: "row"
//             },
//             alignItems: "center",
//             gap: 6,
//           }}
//         >
//           {/* Left Side Text */}
//           <Box
//             sx={{
//               flex: 1,
//               textAlign: {
//                 xs: "center",
//                 md: "left"
//               },
//               justifyContent: "center",
//               display: "flex",
//               flexDirection: "column"
//             }}
//           >
//             <Box
//               sx={{
//                 textTransform: "uppercase",
//                 color: "#A3C9F9",
//               }}
//               className="poppins-medium"
//             >
//               Pour les professionnels de la beauté
//             </Box>
//             <StyledH3 className="archivo-bold">
//               Développez votre activité en ligne
//             </StyledH3>
//             <StyledP>
//               Rejoignez <strong>Diarytree</strong>, notre outil de gestion moderne dédié aux salons de coiffure et instituts de beauté. Simplifiez vos réservations, fidélisez votre clientèle.
//             </StyledP>
//             <CustomLink className="nav-item nav-link rounded-button filled-button action-button">
//               Rejoignez Diarytree
//             </CustomLink>
//           </Box>

//           {/* Right Side Screens */}
//             <Grid
//               container
//               spacing={2}
//               justifyContent="center"
//               alignItems="flex-end"
//               sx={{ flex: 1, position: 'relative', height: 400 }}
//             >
//               {/* Web Screen - Bigger and in the back */}
//               <Grid
//                 item
//                 xs={4}
//                 sx={{
//                   position: 'relative',
//                   zIndex: 1,
//                   transform: 'scale(1.2) translateY(20px)',
//                 }}
//               >
//                 <StyledImage src={FeatImage01} alt="Web Screen" />
//                 <StyledCaption>Web</StyledCaption>
//               </Grid>

//               {/* Mobile Screen - In front with higher offset */}
//               <Grid
//                 item
//                 xs={4}
//                 sx={{
//                   position: 'relative',
//                   zIndex: 3,
//                   transform: 'scale(1.3) translateY(-40px)',
//                 }}
//               >
//                 <StyledImage src={FeatImage01} alt="Mobile Screen" />
//                 <StyledCaption>Mobile</StyledCaption>
//               </Grid>

//               {/* iPad Screen - Behind Mobile */}
//               <Grid
//                 item
//                 xs={4}
//                 sx={{
//                   position: 'relative',
//                   zIndex: 0,
//                   transform: 'scale(1) translateY(30px)',
//                 }}
//               >
//                 <StyledImage src={FeatImage01} alt="Tablet Screen" />
//                 <StyledCaption>iPad</StyledCaption>
//               </Grid>
//             </Grid>

//         </Box>
//       </Container>
//     </div>
//   );
// };

// const StyledImage = styled.img`
//   width: 100%;
//   border-radius: 12px;
//   box-shadow: 0px 10px 20px rgba(0,0,0,0.3);
//   object-fit: contain;
// `;

// const StyledCaption = styled.p`
//   text-align: center;
//   margin-top: 10px;
//   font-size: 0.9rem;
//   color: #ccc;
// `;

// const StyledP = styled.p`
//   font-size: 1rem;
//   margin-top: 20px;
//   @media (max-width: 900px) {
//     text-align: center;
//   }
// `;

// const StyledH3 = styled.h3`
//   font-size: 2.5rem;
//   margin-top: 20px;
//   line-height: 1.2;
//   @media (max-width: 900px) {
//     text-align: center;
//     font-size: 2rem;
//   }
// `;

// export default CTASection;
